import React, {useReducer, useContext, useEffect} from 'react';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import { Context } from '../shared/context/context';
import { reducer } from '../shared/reducer/reducer';
import {AppRouter} from "./AppRouter";
import {watchNewVersion} from './newVersion';
import 'bootstrap/dist/css/bootstrap.min.css';
// antd's colours as CSS variables, so the primary one is the portal's blue (the owner's Роман, 27.10: «больше нашего синего»)
import 'antd/dist/antd.variable.min.css';
import './css/index.css';

// the portal's --light-blue-color
ConfigProvider.config({theme: {primaryColor: '#0966aa'}});

export const App = () => {
  const initialState = useContext(Context);
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => watchNewVersion(), []);

  return (
    <BrowserRouter>
      <Context.Provider value={{ state, dispatch }}>
       <AppRouter/>
      </Context.Provider>
    </BrowserRouter>
  );
};
